module.exports = __webpack_public_path__ + "img/remark_01.2a39e650.svg";